import { flow, map, parseInt, uniqueId } from 'lodash/fp'

export const parseDecimalInt = parseInt(10)
export const mapParseDecimalInt = map(parseDecimalInt)
export const uniqueNumber = () => flow(uniqueId, parseDecimalInt)('')
